module.exports = __webpack_public_path__ + "img/back-arrow-red-dot.43aafa93.svg";